import React, { Component } from 'react';
import { Grid, Icon } from 'semantic-ui-react';
import { skills } from './Skills.data';
import './Skills.css';

export default class Skills extends Component {
    render() {
        return (
            <Grid centered>
                <Grid.Row>
                    <Grid.Column widescreen="14" computer="14" tablet="15" mobile="15">
                        <div id="skills" className="skillsGrid">
                            {skills.map((category, index) => (
                                <article className="skillCard" key={index}>
                                    <div className="skillCardHeader">
                                        <Icon
                                            name={category.icon}
                                            className="skillCardIcon"
                                        />

                                        <h3 className="skillCardTitle">
                                            {category.title}
                                        </h3>
                                    </div>

                                    <div className="skillCardContent">
                                        {category.skills.map((skill, skillIndex) => (
                                            <React.Fragment key={skill}>
                                                <span className="skillName">
                                                    {skill}
                                                </span>

                                                {skillIndex < category.skills.length - 1 && (
                                                    <span className="skillSeparator">
                                                        •
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </article>
                            ))}
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Skills/Skills.js